module.exports = __webpack_public_path__ + "media/application/images/svgs/public_square/favicon-7a80c9e6f37aa2244c760e08c50a8983.svg";